import { render, staticRenderFns } from "./header-yfh.vue?vue&type=template&id=1b36f925&scoped=true&"
import script from "./header-yfh.vue?vue&type=script&lang=js&"
export * from "./header-yfh.vue?vue&type=script&lang=js&"
import style0 from "./header-yfh.vue?vue&type=style&index=0&id=1b36f925&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36f925",
  null
  
)

export default component.exports